import React, { useEffect, useState } from "react";
import "./AnnuaireEntrepriseSearchBar.scss";
import { MultiSelect } from "primereact/multiselect";
import { InputText } from "primereact/inputtext";
import { Divider } from "primereact/divider";
import { FaSearch } from "react-icons/fa";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { useFetchGet, useFetchGetConditional } from "Services/api";
import { updateSecondaryTables } from "Redux/Actions/secondaryTablesActions";

const AnnuaireEntrepriseSearchBar = (props) => {
  const [motsclés, setMotsclés] = useState("");
  const [lieu, setLieu] = useState("");
  const [nom, setNom] = useState("");
  const [prenom, setPrenom] = useState("");
  const [secteur, setSecteur] = useState([]);
  const [typeEntreprise, setTypeEntreprise] = useState([]);
  const [effectif, setEffectif] = useState([]);
  const [isSearched, setIsSearched] = useState(false);

  const secteurData = useFetchGetConditional(
    "/sector_of_offers",
    props.auth.token,
    props.secondaryTables.sectorOfOffersData
  );
  const typeEntrepriseData = useFetchGet("/company_types", props.auth.token);
  const effectifData = useFetchGet("/company_total_staffs", props.auth.token);

  useEffect(() => {
    secteurData.loaded &&
      props.handleUpdateSecondaryTables({
        sectorOfOffersData: secteurData.data,
      });
  }, [secteurData.loaded]);

  const handleFilter = (isSearch) => {
    let url = new URL(`${process.env.REACT_APP_BASE_URL_API}/companies`);

    if (!isSearch) {
      props.setUrlCompany(url);
      return;
    }

    if (motsclés != "") url.searchParams.set("keyword", motsclés);
    if (nom != "") url.searchParams.set("nom", nom);
    if (prenom != "") url.searchParams.set("prenom", prenom);
    if (lieu != "") url.searchParams.set("lieu", lieu);

    //Gestion des Arrays of string pour Contract, Category, Education, Sector et Domain
    if (secteur.length > 0) {
      secteur.forEach((item) => url.searchParams.append("sector[]", item.id));
    }
    if (typeEntreprise.length > 0) {
      typeEntreprise.forEach((item) =>
        url.searchParams.append("type[]", item.id)
      );
    }
    if (effectif.length > 0) {
      effectif.forEach((item) =>
        url.searchParams.append("totalStaff[]", item.id)
      );
    }
    props.setUrlCompany(url);
  };

  return (
    <div className="annuaire_search_bar etudiant_bar">
      <h2 className="annuaire_search_bar__title">Trouvez une entreprise</h2>
      <div className="annuaire_search_bar__container">
        <div className="annuaire_search_bar__container__top">
          <div className="annuaire_search_bar__container__top__boxes">
            <div className="annuaire_search_bar__container__top__boxes__box">
              <label className="label-annuaire">MOTS CLÉS</label>
              <span className="annuaire_p-input-icon-left">
                <InputText
                  value={motsclés}
                  onChange={(e) => setMotsclés(e.target.value)}
                  placeholder=" Poste, Entreprise..."
                  className="box__input"
                />
              </span>
            </div>
            <Divider layout="vertical" />
            <div className="annuaire_search_bar__container__top__boxes__box">
              <label className="label-annuaire">
                {" "}
                SECTEUR D&apos;ENTREPRISE
              </label>
              <MultiSelect
                appendTo={document.getElementById("app")}
                value={secteur}
                options={secteurData.data?.sort((a, b) =>
                  a.label.localeCompare(b.label)
                )}
                onChange={(e) => setSecteur(e.value)}
                optionLabel="label"
                placeholder="Choisir un secteur"
                maxSelectedLabels={3}
                selectedItemsLabel={`${secteur.length} options sélectionnées`}
                className="box__input blanc"
              />
            </div>
            <Divider layout="vertical" />
            <div className="annuaire_search_bar__container__top__boxes__box">
              <label className="label-annuaire"> Type d&apos;entreprise</label>
              <MultiSelect
                appendTo={document.getElementById("app")}
                value={typeEntreprise}
                options={typeEntrepriseData.data?.sort((a, b) =>
                  a.label.localeCompare(b.label)
                )}
                onChange={(e) => setTypeEntreprise(e.value)}
                optionLabel="label"
                placeholder="Choisir un type"
                maxSelectedLabels={3}
                selectedItemsLabel={`${typeEntreprise.length} options sélectionnées`}
                className="box__input blanc"
              />
            </div>
            <Divider layout="vertical" />
            <div className="annuaire_search_bar__container__top__boxes__box">
              <label className="label-annuaire"> EFFECTIF</label>
              <MultiSelect
                appendTo={document.getElementById("app")}
                value={effectif}
                options={effectifData.data}
                onChange={(e) => setEffectif(e.value)}
                optionLabel="label"
                placeholder="Choisir l'effectif"
                maxSelectedLabels={1}
                selectedItemsLabel={`${effectif.length} options sélectionnées`}
                className="box__input blanc"
              />
            </div>
            <Divider layout="vertical" />
            <div className="annuaire_search_bar__container__top__boxes__box">
              <label className="label-annuaire">lieu</label>
              <InputText
                value={lieu}
                onChange={(e) => setLieu(e.target.value)}
                placeholder=" Pays, ville"
                className="box__input"
              />
            </div>
          </div>
          <div
            className="annuaire_search_bar__container__top__inputSearch not_mobile"
            onClick={() => {
              setIsSearched(true);
              handleFilter(true);
            }}
          >
            <FaSearch />
          </div>
        </div>
        <div className="annuaire_search_bar__container__bottom">
          <ul className="ul_entreprises">
            <li>
              <label className="label-min-prenom">Prénom :</label>
              <label className="label-annuaire">Prénom</label>
              <InputText
                value={prenom}
                onChange={(e) => setPrenom(e.target.value)}
                placeholder="Alex, Emma, Julie"
                className="box__input"
              />
            </li>
            <li>
              <label className="label-min-nom">Nom :</label>
              <label className="label-annuaire">Nom</label>
              <InputText
                value={nom}
                onChange={(e) => setNom(e.target.value)}
                placeholder="Lebon, Dupont"
                className="box__input"
              />
            </li>
            {isSearched && (
              <li className="search_bar_refresh search_bar_refresh__annuaireEntreprise">
                <i
                  className="pi pi-refresh"
                  style={{ fontSize: "1.5rem", fontWeight: "600" }}
                  onClick={() => {
                    setIsSearched(false);
                    setMotsclés("");
                    setNom("");
                    setPrenom("");
                    setLieu("");
                    setSecteur([]);
                    setTypeEntreprise([]);
                    setEffectif([]);
                    handleFilter(false);
                  }}
                />
              </li>
            )}
          </ul>
        </div>
        <div
          className="annuaire_search_bar__container__top__inputSearch not_desktop"
          onClick={() => {
            setIsSearched(true);
            handleFilter(true);
          }}
        >
          <FaSearch />
        </div>
      </div>
    </div>
  );
};

AnnuaireEntrepriseSearchBar.propTypes = {
  auth: PropTypes.object,
  setUrlCompany: PropTypes.func,
  secondaryTables: PropTypes.object,
  handleUpdateSecondaryTables: PropTypes.func,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  secondaryTables: state.secondaryTables,
});
const mapDispatchToProps = (dispatch) => ({
  handleUpdateSecondaryTables: (value) => {
    dispatch(updateSecondaryTables(value));
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AnnuaireEntrepriseSearchBar);
